import reports from "./reports";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [reports]
};

export default menuItems;
